import type {StateProvider} from '@uirouter/angularjs';
import UsersController from './users.controller';
import template from './users.tpl.ftl';
import type {PermissionsDataService} from '../../commons/data-services/permissions.data-service';

/*@ngInject*/
export default function usersRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state('users', {
            url: '/users',
            templateUrl: template,
            controller: UsersController,
            controllerAs: 'uc',
            resolve: {
                /*@ngInject*/
                permissions: (cachedPermissionsDataService: PermissionsDataService) => UsersController.getUserPermissions(cachedPermissionsDataService)
            }
        });
}